import * as React from "react";

const NISCustonWrenchIcon: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.8886 4.86716C13.8205 4.5838 13.4608 4.48911 13.2548 4.69518L11.4607 6.48955L9.51303 6.48955V4.54189L11.3072 2.74752C11.5132 2.54152 11.4185 2.18173 11.1352 2.11377C10.58 1.98034 9.97883 1.97054 9.35586 2.11959C7.91563 2.46412 6.7918 3.68756 6.56211 5.15006C6.44014 5.75779 6.49873 6.36482 6.68155 6.91325L2.50733 11.0875C1.84827 11.7465 1.84827 12.8146 2.50733 13.4734C2.81577 13.8039 3.24702 13.989 3.65811 13.989C4.0692 13.989 4.52155 13.8242 4.85131 13.4947L9.02553 9.32052C9.57537 9.50183 10.1812 9.56052 10.8108 9.46124C12.2735 9.23061 13.4967 8.10655 13.8412 6.66749C14.0315 6.02263 14.0222 5.42263 13.8886 4.86716ZM3.8667 12.6765C3.55616 12.6765 3.3042 12.4246 3.3042 12.114C3.3042 11.8033 3.55616 11.5515 3.8667 11.5515C4.17725 11.5515 4.4292 11.8033 4.4292 12.114C4.4292 12.4258 4.17725 12.6765 3.8667 12.6765Z"
                fill="#2B5197"
            />
        </svg>
    );
};

export default React.memo(NISCustonWrenchIcon);
